module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"new":"Create New Submission","top":"Top"},"zh_hk":{"new":"建立新申請","top":"返回頁首"},"zh_cn":{"new":"建立新申请","top":"返回页首"}}')
  delete Component.options._Ctor
}
